
import { computed, defineComponent, PropType } from "vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { scillonianDestinationNames, skybusDestinationNames } from "@/config/global.strings";

export default defineComponent({
	components: {
		BaseSvg,
	},
	props: {
		fromDestination: String,
		toDestination: String,
		direction: Number as PropType<DirectionEnum>,
	},
	setup(props) {
		const bookingStore = useBookingStore();
		const destinationNames = computed(() => {
			if(bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.FlyAndSail){
				switch(props.direction) {
					case DirectionEnum.Outward:
						return skybusDestinationNames;
					default:
						return scillonianDestinationNames; 
				}
			}
			else if(bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.SailAndFly){
				switch(props.direction) {
					case DirectionEnum.Return:
						return skybusDestinationNames;
					default:
						return scillonianDestinationNames; 
				}
			}
			else {
				return bookingStore.getDestinationNames;
			}			
		});

		const icon = computed(() => {
			if (bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.FlyAndSail) {
				switch (props.direction) {
					case DirectionEnum.Outward:
						return "vessel-aircraft";
					default:
						return "vessel-ship";
				}
			} 
			else if (bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.SailAndFly) {
						switch (props.direction) {
							case DirectionEnum.Return:
								return "vessel-aircraft";
							default:
								return "vessel-ship";
						}
			} 
			else {
				switch (bookingStore.getBooking.modeOfTravel) {
					case ModeOfTravelEnum.Skybus:
						return "vessel-aircraft";
					default:
						return "vessel-ship";
				}
			}
		});

		return { DirectionEnum, icon, destinationNames };
	},
});
